module.exports = __webpack_public_path__ + "img/bemajor-big-1.1d52265e.jpg";